var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExams = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.211 7.247a2.728 2.728 0 0 0-.524-1.547C15.43 3.989 14.43 2.924 12.78 1.651A2.683 2.683 0 0 0 11.2 1.1c-.605-.013-1.21-.02-1.814-.02-1.939 0-3.502.059-5.12.171a2.747 2.747 0 0 0-2.557 2.566 93.291 93.291 0 0 0-.18 5.834c0 2 .062 3.952.181 5.835a2.747 2.747 0 0 0 2.557 2.568c.367.025.734.047 1.102.067M14.604 10.65l-5.198 4.554-1 2.839c-.16.457.271.964.75.88l3.022-.536 5.32-4.318c.883-.718.925-2.102.092-3.058-.814-.931-2.15-1.092-2.986-.361Z",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.677 6.329 5.991 7.55c.619-1.601 1.133-2.304 2.3-3.258M4.677 11.688l1.314 1.222c.619-1.6 1.133-2.304 2.3-3.257",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgExams;